module.exports = __webpack_public_path__ + "img/business_intro_1.46cf1104.jpg";